import { render, staticRenderFns } from "./channel_list.vue?vue&type=template&id=aeefb142&scoped=true"
import script from "./channel_list.vue?vue&type=script&lang=ts"
export * from "./channel_list.vue?vue&type=script&lang=ts"
import style0 from "./channel_list.vue?vue&type=style&index=0&id=aeefb142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefb142",
  null
  
)

export default component.exports